import {ready} from "./utils/ready"
import gravityForms from "./components/gravity-forms";

ready(() => {
    gravityForms();
})